<app-loader *ngIf="loginCarg"></app-loader>
<div class="modal-content2">
  <div class="modal-header">
    <h5 class="modal-title" *ngIf="!correoEnviado">Recuperar contraseña</h5>
    <button
      class="close"
      data-dismiss="modal"
      aria-label="Close"
      (click)="onNo()"
      type="button"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <!-- <form [formGroup]="loginFormRecover" *ngIf="!isVerified; else formPasswordFields"> -->
    <form [formGroup]="loginFormRecover" *ngIf="!isVerified">
      <h2>
        Ingresa tu número de celular o correo electrónico para iniciar el proceso de recuperación de contraseña.
      </h2>

      <div class="form-group">
        <app-input-text
          type="text"
          label="Número de celular o correo electrónico"
          placeholder="Ingresa tu correo o número de celular"
          frmControl="email"
          class_label="white"
          [formParent]="loginFormRecover"
          (input) = "onEmailInput($event)"
        ></app-input-text>
      </div>

      <button
        type="submit"
        class="btn btn-primary btn-block"
        (click)="recover()"
        [disabled]="!loginFormRecover.valid"
      >
        Continuar
      </button>
    </form>

    <form #formPasswordFields [formGroup]="passwordFieldsFormRecover" *ngIf="isVerified">
      <h2>
        Ingresa tu nueva contraseña y confírmala para completar el proceso de actualización.
      </h2>

      <div class="form-group password-group">
        <app-input-text
          type="{{ typePassword ? 'password' : 'text' }}"
          label="Nueva contraseña"
          placeholder="Contraseña"
          frmControl="password"
          class_label="white"
          [formParent]="passwordFieldsFormRecover"
        ></app-input-text>
        <label
        class = "password-advice"
        *ngIf="passwordFieldsFormRecover.get('password')?.valid || !passwordFieldsFormRecover.get('password')?.dirty"
        [ngStyle]="{'color': passwordFieldsFormRecover.get('password')?.dirty ? '#567B2D' : '#807F7E'}"
        >
          La contraseña debe tener al menos 8 caracteres, incluyendo una minúscula y un número.
        </label>
      </div>
      <div class="form-group password-group">
        <app-input-text
          type="{{ typePassword ? 'password' : 'text' }}"
          label="Confirmar nueva contraseña"
          placeholder="Contraseña"
          frmControl="confirmPassword"
          class_label="white"
          [formParent]="passwordFieldsFormRecover"
        ></app-input-text>
      </div>

      <button
        type="submit"
        class="btn btn-primary btn-block"
        (click)="changePassword()"
        [disabled]="!passwordFieldsFormRecover.valid"
      >
        Restablecer contraseña
      </button>
    </form>
  </div>
</div>
